import type { GitRefQueryParamsProps } from "../BranchSelector/useProjectGitRef";
import RunbookRunNowLayout from "./RunbookRunNowLayout";
interface RunbookRunSnapshotPageProps extends GitRefQueryParamsProps {
    runbookSnapshotId: string;
}
export function RunbookRunSnapshotPage({ runbookSnapshotId, queryParams, setQueryParams }: RunbookRunSnapshotPageProps) {
    return <RunbookRunNowLayout runbookSnapshotId={runbookSnapshotId} goal={{}} queryParams={queryParams} setQueryParams={setQueryParams}/>;
}
